module.exports = __webpack_public_path__ + "static/media/nav-bg-maankaytto.16024bc4.svg";